import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { ButtonComponent, TagComponent, TagVariant } from '@catch/general-ui';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faPaperPlane } from '@fortawesome/pro-light-svg-icons';
import { TranslocoPipe } from '@jsverse/transloco';
import { PlatformCompanyLogoComponent } from '../../../../components/company-logo/platform-company-logo.component';
import { PlatformActionItem } from '../../../../models/platform.models';
import { PlatformDashboardService } from '../../../../services/platform-dashboard.service';

@Component({
  selector: 'app-platform-dashboard-task-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ButtonComponent,
    TagComponent,
    FontAwesomeModule,
    TranslocoPipe,
    PlatformCompanyLogoComponent,
  ],
  templateUrl: './platform-dashboard-task-item.component.html',
  styleUrl: './platform-dashboard-task-item.component.scss',
})
export class PlatformDashboardTaskItemComponent {
  readonly dashboard = inject(PlatformDashboardService);
  readonly actionItem = input.required<PlatformActionItem>();
  readonly complete = output<number>();

  readonly TagVariant = TagVariant;
  readonly icons = {
    apply: faPaperPlane,
  };

  /**
   * Opens the follow-up choice for this action item.
   */
  openChoice(): void {
    this.complete.emit(this.actionItem().applicationId);
  }
}
